"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = value => {
  // required
  if (value === undefined || value === null) {
    return true;
  }

  if (!/^[a-zA-Z\s]+$/.test(value)) {
    return false;
  }

  return true;
};

exports.default = _default;
